module.exports = __webpack_public_path__ + "img/image31.1243d77c.png";